import React from 'react';
import AccountsPage from '../pages/AccountsPage';
import StocksPage from '../pages/StocksPage';
import PersonnelPage from '../pages/PersonnelPage';
import BankAccountsPage from '../pages/BankAccountsPage';
import ProspectAccountsPage from '../pages/ProspectAccountsPage';

const PAGES = {
  cari: AccountsPage,
  prospect: ProspectAccountsPage,
  stok: StocksPage,
  personel: PersonnelPage,
  banka: BankAccountsPage,
};

const TITLES = {
  cari: 'Cari Hesaplar',
  prospect: 'Potansiyel Cariler',
  stok: 'Stok / Ürünler',
  personel: 'Personel',
  banka: 'Banka Hesapları',
};

/**
 * Mevcut modül sayfasını tam ekran overlay olarak açar.
 * autoOpenNew=true ile sayfa açılır açılmaz "Yeni" formu açılır.
 * onSaved(record) → yeni kayıt başarıyla oluşturuldu (overlay kapatılabilir).
 *
 * Props:
 *  - type: 'cari' | 'stok' | 'personel' | 'banka'
 *  - onClose()
 *  - onSaved(record) — başarılı kayıt sonrası otomatik çağrılır
 */
export default function ModuleOverlay({ type, onClose, onSaved }) {
  const Page = PAGES[type];
  if (!Page) return null;

  const handleSaved = (record) => {
    if (onSaved) onSaved(record);
    // Otomatik kapat — modül formu zaten "başarılı" mesajını gösterdi, kullanıcı istersem devam eder ama invoice formuna dönmek mantıklı
    setTimeout(() => { if (onClose) onClose(); }, 300);
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9998,
      background: 'var(--bg-primary)', display: 'flex', flexDirection: 'column',
    }}>
      <div style={{
        padding: '10px 16px',
        borderBottom: '1px solid var(--border-secondary)',
        background: 'var(--bg-card)',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}>
        <div style={{ fontSize: '1rem', fontWeight: 700 }}>
          {TITLES[type] || type} <span style={{ color: 'var(--text-tertiary)', fontSize: '0.82rem', fontWeight: 400 }}>— Yeni Kayıt</span>
        </div>
        <button
          onClick={onClose}
          style={{
            padding: '6px 16px', border: '1px solid var(--border-secondary)',
            background: 'var(--bg-secondary)', color: 'var(--text-primary)',
            borderRadius: 8, cursor: 'pointer', fontSize: '0.85rem',
            display: 'flex', alignItems: 'center', gap: 6,
          }}
          title="Geri Dön"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m15 18-6-6 6-6"/></svg>
          Geri Dön
        </button>
      </div>
      <div style={{ flex: 1, overflow: 'auto' }}>
        <Page autoOpenNew onSaved={handleSaved} />
      </div>
    </div>
  );
}
